import * as React from 'react';
const SvgTune = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    fill="none"
    viewBox="0 0 17 16"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.702 1.667a2.418 2.418 0 0 1 4.596 0h1.869a.75.75 0 0 1 0 1.5h-1.869a2.418 2.418 0 0 1-4.596 0H.75a.75.75 0 1 1 0-1.5zM12 1.5a.917.917 0 1 0 0 1.833.917.917 0 0 0 0-1.833M8.869 12.084a2.418 2.418 0 0 1 4.596 0h2.702a.75.75 0 0 1 0 1.5h-2.702a2.418 2.418 0 0 1-4.596 0H.75a.75.75 0 0 1 0-1.5zm2.298-.168a.917.917 0 1 0 0 1.834.917.917 0 0 0 0-1.834M4.917 5.209a2.42 2.42 0 0 0-2.298 1.666H.75a.75.75 0 0 0 0 1.5h1.869a2.418 2.418 0 0 0 4.596 0h8.952a.75.75 0 0 0 0-1.5H7.215a2.42 2.42 0 0 0-2.298-1.666M4 7.624a.917.917 0 1 1 1.833 0 .917.917 0 0 1-1.833 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTune;
